// extracted by mini-css-extract-plugin
export default {"viewInBookingModuleContainer":"activity_tabs-module___viewInBookingModuleContainer___a6823ff8","compareAlert":"activity_tabs-module___compareAlert___f21a8aaa"};